module.exports = __webpack_public_path__ + "static/media/tienda.b7f7d315.png";